




















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import * as def from "@/definitions";

import { Product as ProductClass } from "@/data/productCategory/product/product";

import { UserAgentHelper } from "@/helper/userAgentHelper"
import { ResourceHelper } from "@/helper/resourceHelper";

@Component({
  components: {}
})
export default class Product extends Vue {
  @Prop()
  private product!: ProductClass;
  @Prop()
  private selectedProduct!: ProductClass;

  imagePath= ""

  mounted() {
    this.imagePath = this.product.imagePath
  }

  error(){
    if(UserAgentHelper.getBrowser() != "ie"){
      this.imagePath = ResourceHelper.getResource('noimage.png');
    }
  }

  get productName() {
    return (
      this.product.paperList[0].description.split(/\r\n|\r|\n/)[0] +
      this.product.paperList[0].description.split(/\r\n|\r|\n/)[1]
    );
  }

  selectProduct() {
    this.$emit(
      "selectProduct",
      this.product.id,
      this.product.productCategoryId
    );
  }

  decide(){
    this.$emit("decide");
  }

    private get userConfigBorderLineStyle(){
        var style = {
            border : "solid 4px " + this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }

    private get btnStyle(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }
}
